var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBellActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 12,
    fill: "#36d66b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1831 12.6149C24.4812 12.224 23.671 12 22.8029 12H21.0999C18.1555 12 15.8774 14.5806 16.2426 17.5023L16.3219 18.1372C16.4681 19.3063 16.041 20.4741 15.1751 21.2731C13.9924 22.3645 13.6638 24.1016 14.3662 25.5496L14.4695 25.7627C15.1333 27.1311 16.5205 28 18.0414 28H26.2623C27.5656 28 28.7785 27.3342 29.4783 26.2347C30.4661 24.6826 30.2045 22.6465 28.8564 21.3945L28.8125 21.3538C28.3991 20.9698 28.0805 20.5067 27.8697 20C27.7836 19.7931 27.7154 19.5789 27.6662 19.3599M19.1832 31L19.4832 31.4C20.8332 33.2 23.5332 33.2 24.8832 31.4L25.1832 31",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1836 16C29.1836 17.1046 28.2882 18 27.1836 18C26.079 18 25.1836 17.1046 25.1836 16C25.1836 14.8954 26.079 14 27.1836 14C28.2882 14 29.1836 14.8954 29.1836 16Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellActive);
export default __webpack_public_path__ + "static/media/bell-active.d9f3068414a56c7cd4e6dfda7bcf50bd.svg";
export { ForwardRef as ReactComponent };